
        var result = require("!!../../../../node_modules/css-loader/index.js!./training.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/training/training.component.css
// module id = 1251
// module chunks = 0